import Link from 'next/link';
import { ReactNode } from 'react';

import { CONSENT_EMAIL, DATA_INSPECTORATE, GDPR, PHONE_NUMBER, SUPPORT_EMAIL } from './contact';

export const phoneValue = {
  phone: (chunks: ReactNode) => (
    <a
      href={`tel:${PHONE_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-orange-dark"
    >{`${chunks}`}</a>
  )
};

export const supportValue = {
  support: (chunks: ReactNode) => (
    <a
      href={`mailto:${SUPPORT_EMAIL}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-orange-dark"
    >{`${chunks}`}</a>
  )
};

export const dataInspectorateValue = {
  data: (chunks: ReactNode) => (
    <Link href="/privacy">
      <a
        href={DATA_INSPECTORATE}
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-dark"
      >{`${chunks}`}</a>
    </Link>
  )
};

export const consentValue = {
  consent: (chunks: ReactNode) => (
    <a
      href={`mailto:${CONSENT_EMAIL}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-orange-dark"
    >{`${chunks}`}</a>
  )
};

export const privacyValue = {
  privacy: (chunks: ReactNode) => (
    <Link href="/privacy">
      <a className="text-orange-dark">{`${chunks}`}</a>
    </Link>
  )
};

export const gdprValue = {
  gdpr: (chunks: ReactNode) => (
    <a href={GDPR} target="_blank" rel="noopener noreferrer" className="text-orange-dark">{`${chunks}`}</a>
  )
};

export const termsValue = {
  terms: (chunks: ReactNode) => (
    <Link href="/terms">
      <a className="text-orange-dark">{`${chunks}`}</a>
    </Link>
  )
};
